import React, { Component } from 'react';
export function WhatYouGet() {
  const tableData = [{
    item: '📘 TOME 1: Little Explorers — 50 Pages',
    value: '$15'
  }, {
    item: '📗 TOME 2: Brain Builders — 50 Pages',
    value: '$15'
  }, {
    item: '📙 TOME 3: Focus Warriors — 50 Pages',
    value: '$15'
  }, {
    item: '📕 TOME 4: Logic Masters — 50 Pages',
    value: '$15'
  }, {
    item: '📒 TOME 5: Memory Champions — 50 Pages',
    value: '$15'
  }, {
    item: '📓 TOME 6: Young Geniuses — 55 Pages',
    value: '$15'
  }, {
    item: '🎁 BONUS 1: 30-Day Focus Planner',
    value: '$17'
  }, {
    item: '🎁 BONUS 2: Emotion Control for Kids',
    value: '$17'
  }, {
    item: '🎁 BONUS 3: Screen-Free Playbook',
    value: '$17'
  }, {
    item: '🎁 BONUS 4: Parent Quick-Start Guide',
    value: '$17'
  }, {
    item: '🎁 BONUS 5: Focus Rewards System',
    value: '$17'
  }];
  return <section className="bg-white py-16 px-4 border-t border-border" data-id="element-245">
      <div className="max-w-4xl mx-auto" data-id="element-246">
        <div className="text-center mb-10" data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-heading font-black text-navy mb-3" data-id="element-248">
            🎁 EVERYTHING YOU GET TODAY
          </h2>
        </div>

        <div className="overflow-x-auto mb-8 rounded-2xl border-2 border-navy shadow-lg bg-white" data-id="element-249">
          <table className="w-full text-left border-collapse" data-id="element-250">
            <thead data-id="element-251">
              <tr className="bg-lightgray border-b-2 border-navy" data-id="element-252">
                <th className="p-5 text-navy font-heading font-bold w-2/3" data-id="element-253">
                  Component
                </th>
                <th className="p-5 font-heading font-bold w-1/3 text-navy text-right" data-id="element-254">
                  Value
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border" data-id="element-255">
              {tableData.map((row, i) => <tr key={i} className="hover:bg-lightgray transition-colors" data-id="element-256">
                  <td className="p-5 text-ink font-medium" data-id="element-257">{row.item}</td>
                  <td className="p-5 text-muted text-right font-medium" data-id="element-258">
                    {row.value}
                  </td>
                </tr>)}
              <tr className="bg-lightgray border-t-2 border-navy" data-id="element-259">
                <td className="p-5 text-navy font-heading font-bold text-lg" data-id="element-260">
                  TOTAL REAL VALUE
                </td>
                <td className="p-5 text-softred font-bold text-lg text-right line-through" data-id="element-261">
                  $175
                </td>
              </tr>
              <tr className="bg-navy" data-id="element-262">
                <td className="p-6 text-gold font-heading font-black text-xl md:text-2xl" data-id="element-263">
                  YOUR PRICE TODAY
                </td>
                <td className="p-6 text-gold font-heading font-black text-2xl md:text-3xl text-right" data-id="element-264">
                  $19 USD
                </td>
              </tr>
              <tr className="bg-orange" data-id="element-265">
                <td className="p-4 text-white font-heading font-bold text-lg text-center" colSpan={2} data-id="element-266">
                  YOU SAVE $156
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}